<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card class="mt-2">
          <v-card-title style="color:#1f245b">Kondisi Saat Ini {{devices.station}} - {{devices.location}}</v-card-title>
          <v-divider class="mx-2"></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headersCondition"
                  :items="TMA"
                  :items-per-page="5"
                  :calculate-widths="true"
                  :mobile-breakpoint="500"
                  item-key="station"
                  class="elevation-1"
                  hide-default-footer
                  disable-sort
                  :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                    prevIcon: 'mdi-minus',
                    nextIcon: 'mdi-plus'
                  }"
                >
                <template v-slot:[`item.time`]="{ item }">
                  {{updateTime(item.time)}}
                </template>
                <template v-slot:[`item.condition`]="{ item }">
                  <span v-if="item.condition==='Hujan'">
                    <v-chip
                      color="success darken-1"
                    >
                      {{item.condition}}
                    </v-chip>
                  </span>
                  <span v-else-if="item.condition==='Tidak Hujan'">
                    <v-chip
                      color="grey"
                      dark
                    >
                      {{item.condition}}
                    </v-chip>
                  </span>
                  <span v-else>
                    <v-chip
                      color="error"
                    >
                      {{item.condition}}
                    </v-chip>
                  </span>
                </template>
                <template v-slot:[`item.volt`]="{ item }">
                  <span v-if="parseFloat(item.volt)>parseFloat(item.voltLow)">
                    <v-chip
                      color="success darken-1"
                    >
                      {{item.volt}}
                    </v-chip>
                  </span>
                  <span v-else>
                    <v-chip
                      color="error"
                    >
                      {{item.volt}}
                    </v-chip>
                  </span>
                </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
   
  </v-container>
</template>

<script>
// import firebase from "firebase/app"
import { db }from "@/firebase/db.js"
import moment from 'moment'

  export default {
    name: 'DataPage',

    data: () => ({
      data:[],
      tableLoad:true,
      TMA:[],
      headersCondition: [
        { text: 'Tinggi (cm)', value: 'ketinggian' },
        { text: 'Status Alat', value: 'condition' },
        { text: 'Battery (V)', value: 'volt' },
        { text: 'Signal', value: 'signal' },
      ],
    }),
    async mounted () {
      let loader = this.$loading.show()
      const date=new Date();
      this.offset=date.getTimezoneOffset()/(-60)

      await db.collection('radar').doc(this.$route.params.mac).onSnapshot((doc) => {
        this.TMA=[{
          station: doc.data().station,
          expire: doc.data().expire,
          location: doc.data().location,
          volt: doc.data().volt,
          ketinggian: doc.data().ketinggian,
          condition: (Date.now()/1000 - parseInt(doc.data().timestamp) > parseInt(doc.data().periodic)*120)? 'Mati' : doc.data().bahaya=="1" ? 'Bahaya' : doc.data().waspada=="1" ? 'Waspada' : doc.data().evakuasi=="1" ? 'Evakuasi' : 'Normal',
          satuan: doc.data().satuan,
          signal:doc.data().signal,
          time: parseInt(doc.data().timestamp),
          voltLow: doc.data().voltLow
        }]
        loader.hide()
      })
    },
    methods: {
      updateTime (time) {
        return moment.unix(time).utcOffset(this.offset).format("HH:mm, DD MMM YYYY")
      },
      
    }
  }
</script>
